import PropTypes from 'prop-types';

const workspaceShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
});

export default workspaceShape;
